export default "__VITE_ASSET__7a4d1321__"